import Vue from 'vue'
import { CHAVE_EVENTO } from './state'

const mutations = {
  events: (state, events) => Vue.set(state, 'events', events),
  // Persiste a seleção para ela sobreviver ao reload (ver o comentário em state.js).
  currentEventId: (state, id) => {
    try {
      if (id) localStorage.setItem(CHAVE_EVENTO, String(id))
      else localStorage.removeItem(CHAVE_EVENTO)
    } catch (e) { /* localStorage indisponível: segue só em memória */ }
    return Vue.set(state, 'currentEventId', id)
  },
  eventSummary: (state, data) => Vue.set(state, 'eventSummary', data)
}

export default mutations
